// extracted by mini-css-extract-plugin
module.exports = {"miniProgress":"index_miniProgress-1Ytl3","progressWrap":"index_progressWrap-1iN0h","progress":"index_progress-301Ev","target":"index_target-VGicK"};